<app-date-controls (dateChange)="onChangedDate($event)"></app-date-controls>

<div class="my-3 my-3">
    <app-meteogram [date]="date"></app-meteogram>
    <app-east-asia [date]="date"></app-east-asia>
    <app-south-korea [date]="date"></app-south-korea>
</div>